import { formatNumber, CampaignSpentBudget } from "@common";
import { Pie } from "@components";
import { CampaignInfo } from "@store";
import * as React from "react";
import "react-day-picker/lib/style.css";
import "./DashboardAsideComponent.css";
import { LoadingSpinner } from "./LoadingSpinner";
import { LongNameComponent } from "./LongNameComponent";

export interface DashboardAsideProps {
    selectedCampaign: CampaignInfo;
    spentBudget: CampaignSpentBudget & { isLoading: boolean };
}

export function DashboardAsideComponent({ selectedCampaign, spentBudget }: DashboardAsideProps) {
    return (
        <>
            {!selectedCampaign ? (
                <h4 className="empty-campaign-aside-title">Select Campaign to show data</h4>
            ) : (
                <>
                    <section className="campaign-info-item">
                        <h3 className="campaign-info-main-title">
                            {selectedCampaign.campaignName ? (
                                <LongNameComponent name={selectedCampaign.campaignName} />
                            ) : (
                                ""
                            )}
                        </h3>
                        {selectedCampaign.status !== "draft" &&
                            selectedCampaign.status !== "pending" && (
                                <h5 className="campaign-info-main-subtitle">{selectedCampaign.campaignId}</h5>
                            )}
                    </section>
                    <section className="campaign-info-item">
                        <ul>
                            <li>
                                <p className="campaign-info-title">Full Budget</p>
                                {selectedCampaign.budget ? (
                                    <p className="campaign-info-value number-value">
                                        {formatNumber(selectedCampaign.budget.toFixed(2))}{" "}
                                        <span className="budget-value-currency">{selectedCampaign.currency}</span>
                                    </p>
                                ) : (
                                    <p className="campaign-info-value number-value">-</p>
                                )}
                            </li>
                        </ul>
                    </section>
                    <section className="campaign-info-item">
                        {spentBudget.isLoading ? (
                            <span className="loading-label">
                                <LoadingSpinner className="centered-loading" />
                            </span>
                        ) : (
                            <div className="spent-graph">
                                <div className="graph-title-wrap">
                                    <span className="graph-title">
                                        {`${((1 - spentBudget.spentPart) * 100).toFixed(0)}%`}
                                    </span>
                                    <span className="graph-subtitle">Open</span>
                                </div>
                                <Pie
                                    data={[
                                        {
                                            value: spentBudget.spentPart,
                                            color: "rgb(26,127,179)"
                                        },
                                        {
                                            value: 1 - spentBudget.spentPart,
                                            color: "rgba(26,127,179 , 0.2)"
                                        }
                                    ]}
                                    circleWidth={12}
                                    className={"graph-donut"}
                                />
                                <div className="graph-title-wrap graph-bottom-title">
                                    <span className="graph-title ">{`${(spentBudget.spentPart * 100).toFixed(
                                        0
                                    )}%`}</span>
                                    <span className="graph-subtitle">Spent</span>
                                </div>
                            </div>
                        )}
                    </section>
                </>
            )}
        </>
    );
}
